import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=e55d6c88&"
import script from "./contact.js?vue&type=script&lang=js&"
export * from "./contact.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports